/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $CreateContractRequest = {
  type: 'CreateContract',
} as const;
